<template>
  <div class="home">
    <div class="btn-subscribe-container fixed-buttons position-fixed p-0 d-flex flex-column align-items-end" style="bottom: 0; right: 0; z-index: 10">
      <button type="button" class="d-none d-md-block btn btn-transparent" @click="scrollTop">
        <img src="@/assets/images/btnscrolltop.svg" alt="Botão rolar para cima" />
      </button>
      
      <router-link  :to="'/vagas/' + $store.state.bancoDeTalentos + '/inscricao'" class="w-100 btn btn-transparent d-flex justify-content-center justify-content-md-end" @click="scrollTop">
        <img src="@/assets/images/btn-quero-me-inscrever-mobile.svg" alt="Inscreva-se" />
      </router-link>
    </div>

    <div class="row" id="banner">
      <div class="col-12 px-0">
        <img src="@/assets/images/banner.png" alt="Programa de Trainee 2025 do Grupo Boticário #VAIDEGRUPOBOTICÁRIO" width="100%" class="d-none d-md-block"/>
        <img src="@/assets/images/banner-mobile.png" alt="Programa de Trainee 2025 do Grupo Boticário #VAIDEGRUPOBOTICÁRIO" width="100%" class="d-block d-md-none" />
      </div>
    </div>

    <div class="row mt-5 pt-5 pb-0 pb-lg-5" id="sobre">
      <div class="col-11 col-lg-9 mx-auto">
        <div class="row">
          <div class="col-6">
            <!-- <img src="@/assets/images/vaidegrupoboticario.svg" alt="Título #Vai de Grupo Boticário" class="mb-5" width="300px" /> -->
          </div>

          <div class="col-6 d-flex justify-content-end justify-content-lg-start">
            <!-- <div class="detalhe"></div> -->
          </div>
        </div>

        <div class="row flex-column-reverse flex-lg-row">
          <div class="col-12 col-lg-6">
            <p>Somos o <strong>Grupo Boticário</strong>, e nosso propósito é criar oportunidades para que a beleza transforme a vida das pessoas e, assim, transforme o mundo ao nosso redor. Esse propósito é o que nos conecta com o nosso maior tesouro – o nosso cliente – e é também o alicerce que ampara as nossas principais conquistas</p>
            
            <p>Hoje somos um dos maiores grupos empresariais do Brasil, a maior franquia de beleza do mundo e temos a marca de cosméticos mais amada do país.</p>

            <p>Construímos o hoje e o amanhã do melhor e maior ecossistema de beleza para o mundo.</p>
          </div>

          <div class="col-12 col-lg-6 d-flex flex-column-reverse flex-lg-column align-items-end mb-4 mb-lg-0 sobre-video-content">
            <!-- <img src="@/assets/images/juntosconstruimos.svg" alt="Título Juntos Construindo #Uma Beleza de Futuro" class="w-50 mt-3 mr-4 mt-lg-0 mb-lg-3 mr-md-4" /> -->
            
            <div class="iframe-border">
              <iframe 
                src="https://www.youtube.com/embed/cszUJ9BnlmQ" 
                title="YouTube video player" 
                frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerpolicy="strict-origin-when-cross-origin" 
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" id="pq-grupo-boticario">
      <div class="col-12 col-md-10 mx-auto">
        <img src="@/assets/images/pq-grupo.svg" alt="Por que o Grupo Boticário?" class="d-none d-md-block" />
        <img src="@/assets/images/pq-grupo-mobile.svg" alt="Por que o Grupo Boticário?" class="d-block d-md-none" />
      </div>

      <div class="col-12 col-md-10 mx-auto">
        <div class="numbers">
          <div class="row">
            <div class="col-3">
              <div class="number-item">
                <div class="number-item-head">
                  <img src="@/assets/images/key-icon-open.svg" alt="icon key" />
                  
                  <p>
                    <span>somos um</span> <br />
                    ecossistema <br />
                    <span>formado por</span> 
                  </p>
                </div>

                <div class="number-item-body">
                  <p>
                    15 <br />
                    <span>marcas</span>
                  </p>
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="number-item">
                <div class="number-item-head">
                  <img src="@/assets/images/key-icon-open.svg" alt="icon key" />
                  
                  <p>
                    <span>presentes</span> <br />
                    em mais de 
                  </p>
                </div>

                <div class="number-item-body">
                  <p>
                    40 <br />
                    <span>países</span>
                  </p>
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="number-item">
                <div class="number-item-head">
                  <img src="@/assets/images/key-icon-open.svg" alt="icon key" />
                  
                  <p>
                    <span>com mais de</span>
                  </p>
                </div>

                <div class="number-item-body">
                  <p>
                    4000 <br />
                    <span>lojas físicas</span>
                  </p>
                </div>
              </div>
            </div>

            <div class="col-3">
              <div class="number-item">
                <div class="number-item-head">
                  <img src="@/assets/images/key-icon-open.svg" alt="icon key" />
                  
                  <p>
                    <span>e mais de</span>
                  </p>
                </div>

                <div class="number-item-body">
                  <p>
                    20k <br />
                    <span>colaboradores diretos</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 px-0 mt-5">
        <img src="@/assets/images/pq-grupo-texts-bg-mobile.png" alt="" class="d-block d-md-none" style="width: 100%;" />
      </div>

      <div class="col-11 col-md-10 mx-auto pq-grupo-texts">
        <div class="row pt-5">
          <div class="col-12 col-md-6">
            <p class="text-white" style="font-weight: 100;">O Programa Trainee do Grupo Boticário é mais que uma decisão de carreira - <strong>é uma oportunidade de impactar o mundo e crescer com propósito</strong>. Além da oportunidade de alavancar a sua carreira em um ambiente dinâmico e plural.</p>

            <p class="text-white" style="font-weight: 100;">Somos um ecossistema que usa <strong>tecnologia e inovação</strong> para reinventar o futuro da beleza no agora. Trabalhamos com ética e responsabilidade para construir uma beleza vanguardista, capaz de fomentar a <strong>sustentabilidade e empreendedorismo</strong>.</p>

            <p class="text-white" style="font-weight: 100;">Esse é o #<strong>Futuro</strong>Da<strong>Beleza</strong></p>
          </div>
          <div class="col-12 col-md-6"></div>
        </div>
      </div>
    </div>

    <div class="row py-5" id="section-carreira-desenvolvimento">
      <div class="col-12 col-md-10 mx-auto">
        <img src="@/assets/images/title-carreira-desenvolvimento.png" alt="Carreira e Desenvolvimento" class="" />
      </div>

      <div class="col-11 col-md-10 mx-auto mt-5">
        <div class="row">
          <div class="col-12 col-md-6">
            <p><strong>O Programa Trainee tem duração de 18 meses, nele você vai conhecer todo o nosso ecossistema: das fábricas ate as lojas.</strong></p>

            <p>Depois, partimos para uma série de cursos internos e externos para impulsionar suas habilidades e competências, preparando você para os desafios do Programa.</p>

            <p>E, além de tudo isso, você contará com a mentoria de uma liderança do Grupo Boticário e vai desenvolver um projeto de impacto ao longo da sua jornada como Trainee, colocando em prática seus aprendizados para moldar o futuro da beleza.</p>
          </div>

          <div class="col-2"></div>

          <div class="col-12 col-md-4" id="collapses-desenvolvimento">
            <b-btn block v-b-toggle="'collapse-trilha-desenvolvimento'" variant="transparent">
              <span><img src="@/assets/images/requisitos-barra.png" alt="" width="20px" class="mt-n3" /></span>
              <span style="font-weight: 200;">trilha de<br /><strong>desenvolvimento</strong><br />geral e personalizada</span>
            </b-btn>

            <!-- <b-collapse id="collapse-trilha-desenvolvimento" role="tabpanel">
              <div class="collapse-content">
                <p>conteúdo</p>
              </div>
            </b-collapse> -->

            <div class="py-2"></div>

            <b-btn block v-b-toggle="'collapse-imersao'" variant="transparent">
              <span><img src="@/assets/images/requisitos-barra.png" alt="" width="20px" class="mt-n3" /></span>
              <span style="font-weight: 100;"><strong>imersão</strong><br />no negócio</span>
            </b-btn>

            <!-- <b-collapse id="collapse-imersao" role="tabpanel">
              <div class="collapse-content">
                <p>conteúdo</p>
              </div>
            </b-collapse> -->

            <div class="py-2"></div>

            <b-btn block v-b-toggle="'collapse-mentoria'" variant="transparent">
              <span><img src="@/assets/images/requisitos-barra.png" alt="" width="20px" class="mt-n3" /></span>
              <span style="font-weight: 100;"><strong>mentoria</strong><br />com lideranças</span>
            </b-btn>

            <!-- <b-collapse id="collapse-mentoria" role="tabpanel">
              <div class="collapse-content">
                <p>conteúdo</p>
              </div>
            </b-collapse> -->

            <div class="py-2"></div>

            <b-btn block v-b-toggle="'collapse-projetos'" variant="transparent">
              <span><img src="@/assets/images/requisitos-barra.png" alt="" width="20px" class="mt-n3" /></span>
              <span style="font-weight: 100;">projetos<br /><strong>de impacto</strong></span>
            </b-btn>

          </div>
        </div>
      </div>
    </div>


    <div class="row" id="sustentabilidade">
      <div class="col-12 col-md-10 mx-auto">
        <div class="row">
          <div class="col-12 col-md-5 mx-auto"></div>
          <div class="col-12 col-md-7 mx-auto pl-0 pl-md-4">
            <p>Acreditamos em uma beleza do futuro. Sustentabilidade e diversidade são parte do nosso DNA. Como *a terceira empresa de beleza mais sustentável do mundo, nossos compromissos para 2030 estão alinhados aos Objetivos de Desenvolvimento Sustentável (ODS) da Organização das Nações Unidas (ONU). De iniciativas que transformam a cadeia de produção a programas sociais, criamos impacto positivo, sempre com foco no respeito e inclusão.</p>

            <p class="text-center"><a href="https://www.grupoboticario.com.br/uma-beleza-de-futuro/" target="_blank"><img src="@/assets/images/btn-iniciativas.svg" alt="" /></a></p>

            <p><small>*Resultado divulgado pelo Corporate Sustainability Assessment (CSA) da S&P Global, avaliação anual das práticas de sustentabilidade das empresas e principal critério de elegibilidade para o Índice de Sustentabilidade Dow Jones (Dow Jones Sustainability Index), em 22 de dezembro de 2023.</small></p>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row">
      <div class="d-flex d-lg-none container-numbers">
        <div class="number">
          <img src="@/assets/images/numbers-1-mobile.svg" alt="somos um ecossistema formado por 15 marcas" />
        </div>

        <div class="number">
          <img src="@/assets/images/numbers-2-mobile.svg" alt="presentes em mais de 40 países" />
        </div>
        
        <div class="number">
          <img src="@/assets/images/numbers-3-mobile.svg" alt="com mais de 4000 lojas físicas" />
        </div>
        
        <div class="number">
          <img src="@/assets/images/numbers-4-mobile.svg" alt="e mais de 20k colaboradores diretos" />
        </div>
      </div>
    </div> -->

    <!-- <div class="row mt-5 pt-5 pb-4 pb-md-5" id="programa">
      <div class="col-11 col-md-9 mx-auto">
        <div class="row">
          <div class="col-7 z-index-1">
            <img src="@/assets/images/programa-card.svg" alt="Programa de Trainee 2025 do Grupo Boticário." class="mb-1 mb-md-5 programa-card" width="300px" />
            
            <img src="@/assets/images/vaidegrupoboticario-secao-programa-mobile.svg" alt="" class="d-block d-md-none mt-4 ml-4"  />
          </div>

          <div class="col-5 d-flex flex-column align-items-end mt-5 mt-md-0 ml-n4 ml-md-n0 pl-0 pl-md-5">
            <img src="@/assets/images/foto-programa.png" alt="" class="mb-md-3 foto-programa" />
            
            <img src="@/assets/images/vaidegrupoboticario-secao-programa.svg" alt="" class="d-none d-md-block align-self-start vaidegrupoboticario-secao-programa"  />
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="row mt-md-5">
      <div class="col-11 col-md-9 mx-auto">
        <div class="row">
          <div class="col-11 col-md-6 mx-auto">
            <p>O <strong>Programa de Trainee 2025 do Grupo Boticário</strong> é a<br />oportunidade perfeita para estudantes que<br />desejam construir o futuro da sua carreira em<br />um ecossistema de beleza dinâmico, inovador<br />e diverso.</p>
            <p>Você é uma pessoa que se identifica com a<br />nossa cultura, quer aprender e conquistar<br />novas experiências com muito protagonismo?</p>
            <p>Vem fazer <strong class="pink_mobile">beleza</strong> com a gente!</p>
          </div>

          <div class="col-11 col-md-6 d-none d-md-block">
            <div class="detalhe"></div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="row">
      <div class="d-flex d-md-none image-between"></div>
    </div> -->

    <!-- <div class="row" id="beleza">
      <div class="col-11 col-md-9 mx-auto">
        <div class="d-none d-md-flex justify-content-center mb-5 pb-5">
          <img src="@/assets/images/title-abeleza.png" alt="Título a Beleza de Crescer Juntos" />
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <div class="d-none d-md-block detalhe mb-4"></div>
            
            <div class="d-flex d-md-block align-items-end">
              <div class="col-6 col-md-12">
                <Slider>
                  <div>
                    <div class="item">
                      <img src="@/assets/images/carousel-1.png" alt="" />
                    </div>
                  </div>
                  
                  <div>
                    <div class="item">
                      <img src="@/assets/images/carousel-2.png" alt="" />
                    </div>
                  </div>
                  
                  <div>
                    <div class="item">
                      <img src="@/assets/images/carousel-3.png" alt="" />
                    </div>
                  </div>
                </Slider>
              </div>
  
              <div class="d-md-none col-6 col-md-12 mb-3 mb-md-0">
                <img src="@/assets/images/title-abeleza-mobile.svg" alt="Título a Beleza de Crescer Juntos" />
              </div>
            </div>
          </div>
          
          <div class="col-12 col-md-6 pt-5">
            <p>Em nosso <strong>Programa de Estágio</strong>, acreditamos que<br />cada jornada de sucesso possui uma trajetória rica<br />em aprendizado continuo. Por isso, o programa<br />possui uma Trilha de Desenvolvimento onde você<br />se desenvolve profissionalmente e, ao mesmo<br />tempo, contribui ativamente para os desafios que<br />constroem o futuro do <strong>Grupo Boticário</strong>.</p>
            <p>Além disso, você terá acompanhamento contínuo<br />da liderança, com feedbacks e metas de<br />desenvolvimento desenhadas para impulsionar seu<br />crescimento.</p>
          </div>
        </div>

        <div class="row mt-5" id="collapses-beleza">
          <div class="col-12 col-md-3 collapses-beleza-item">
            <b-btn block v-b-toggle="'collapse-beleza-1'" variant="transparent">
              Integração<br />Institucional
            </b-btn>

            <b-collapse id="collapse-beleza-1" role="tabpanel">
              <div class="collapse-content">
                <p>Sua jornada começa com uma Integração Institucional, pensado para integrar você à cultura da empresa e às nossas principais áreas de atuação. Esse momento inicial é crucial para que você conheça a ainda mais o nosso negócio e como trabalhamos.</p>
              </div>
            </b-collapse>
          </div>

          <div class="col-12 col-md-3 collapses-beleza-item">
            <b-btn block v-b-toggle="'collapse-beleza-2'" variant="transparent">
              Cursos e<br />Treinamentos
            </b-btn>

            <b-collapse id="collapse-beleza-2" role="tabpanel">
              <div class="collapse-content">
                <p>Sabemos que o aprendizado contínuo é fundamental para o desenvolvimento profissional. Por isso, oferecemos uma série de cursos e treinamentos voltados para o aprimoramento das suas habilidades técnicas e comportamentais. </p>
              </div>
            </b-collapse>
          </div>

          <div class="col-12 col-md-3 collapses-beleza-item">
            <b-btn block v-b-toggle="'collapse-beleza-3'" variant="transparent">
              Rodas de<br />Conversa
            </b-btn>

            <b-collapse id="collapse-beleza-3" role="tabpanel">
              <div class="collapse-content">
                <p>Acreditamos que a troca de experiências é uma poderosa ferramenta de aprendizado. As rodas de conversa são espaços colaborativos para discutir ideias, compartilhar desafios e aprender com líderes, especialistas e pessoas estagiárias de várias áreas.</p>
              </div>
            </b-collapse>
          </div>

          <div class="col-12 col-md-3 collapses-beleza-item">
            <b-btn block v-b-toggle="'collapse-beleza-4'" variant="transparent">
              Projetos<br />de Impacto
            </b-btn>

            <b-collapse id="collapse-beleza-4" role="tabpanel">
              <div class="collapse-content">
                <p>Aqui, você faz a diferença! Durante o programa, você terá a chance de participar de projetos relevantes, que estão diretamente conectados aos desafios reais do Grupo Boticário. Essas iniciativas permitem que você aplique o que está aprendendo e contribua com soluções inovadoras.</p>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div> -->

    <div class="row d-flex d-md-none requisitos-title-mobile z-index-1" ref="requisitosElement" :class="{ 'visible': requisitosVisible }">
      <img src="@/assets/images/foto-requisitos.png" alt="" class="w-50 img-avatar" :class="{ 'animated fadeInDown': requisitosVisible}" style="max-height: 600px;" />

      <img 
        src="@/assets/images/requisitos-title-mobile.svg" alt="Pré-requisitos" 
        class="mb-5 img-title"
        :class="{ 'animated fadeInLeft': requisitosVisible}" 
        style="animation-delay: 0s;" 
      />
    </div>

    <div class="row" id="requisitos" ref="requisitosElement" :class="{ 'visible': requisitosVisible }">
      <div class="col-12 requisitos-bg">
        <div class="row">
          <div class="col-2 requisitos-color"></div>
          <div class="col-10"></div>
        </div>
      </div>

      <div class="col-12 requisitos-content">
        <div class="row">
          <div class="col-2 col-md-4">
            <img src="@/assets/images/foto-requisitos.png" alt="" class="d-none d-md-block" :class="{ 'animated fadeInLeft': requisitosVisible}" />
          </div>

          <div class="col-10 col-md-7 d-flex justify-content-center requisitos-color">
            <div class="content-text" style="max-width: 400px;">
              <img 
                src="@/assets/images/requisitos-title.svg" alt="Pré-requisitos" 
                class="d-none d-md-block mb-5"
                :class="{ 'animated fadeInLeft': requisitosVisible}" 
                style="animation-delay: 0s;" 
              />
                
              <p :class="{ 'animated fadeInRight': requisitosVisible}" style="font-weight: 100; animation-delay: 0.2s;" class="text-white d-flex align-items-start" >
                <img src="@/assets/images/requisitos-barra.png" alt="" class="mr-2 pt-1" />
                <span>Graduação com formação entre<br /><strong>janeiro de 2020 e dezembro de 2024.</strong></span>
              </p>

              <p :class="{ 'animated fadeInRight': requisitosVisible}" style="font-weight: 100; animation-delay: 0.3s;" class="text-white d-flex align-items-start">
                <img src="@/assets/images/requisitos-barra.png" alt="" class="mr-2 pt-1" />
                <span>Aceitamos pessoas formadas em todos os cursos.</span>
              </p>
              
              <p :class="{ 'animated fadeInRight': requisitosVisible}" style="font-weight: 100; animation-delay: 0.4s;" class="text-white d-flex align-items-start">
                <img src="@/assets/images/requisitos-barra.png" alt="" class="mr-2 pt-1" />
                <span>Um segundo idioma <strong>não</strong> é obrigatório.</span>
              </p>
              
              <p :class="{ 'animated fadeInRight': requisitosVisible}" style="font-weight: 100; animation-delay: 0.5s;" class="text-white d-flex align-items-start">
                <img src="@/assets/images/requisitos-barra.png" alt="" class="mr-2 pt-1" />
                <span><strong>Temos 3 modelos de trabalho:</strong><br />remoto, híbrido e presencial<br /><small style="font-size: 12px; font-weight: 100;">*a serem definidos após o processo de seleção*</small></span>
              </p>

              <p :class="{ 'animated fadeInRight': requisitosVisible}" style="font-weight: 100; animation-delay: 0.6s;" class="text-white d-flex align-items-start">
                <img src="@/assets/images/requisitos-barra.png" alt="" class="mr-2 pt-1" />
                <span>Disponibilidade para iniciar em<br /> <strong>janeiro de 2025.</strong> </span>
              </p>

              <!-- <p :class="{ 'animated fadeInRight': requisitosVisible}" style="animation-delay: 0.6s;" class="mt-4">
                <span class="text-black">São Paulo </span> <span class="text-white">• Vila Olímpia</span> <br />
                <span class="text-black">Paraná </span> <span class="text-white">• Curitiba e São José dos Pinhais</span> <br />
                <span class="text-black">Bahia </span> <span class="text-white">• Camaçari</span>
              </p> -->
            </div>
          </div>
        </div>
      </div>      
    </div>

    <div class="row pt-5" id="section-beneficios">
      <div class="col-12 col-md-10 mx-auto">
        <div class="w-100 d-flex flex-column align-items-center justify-content-center col-10 mt-4 mx-auto">
          <img src="@/assets/images/beneficios.svg" alt="benefícios que irão acompanhar a sua jornada" class=""/>
          <img src="@/assets/images/salario.svg" alt="Salário R$ 8.000,00" class="my-5" />
        </div>

        <div class="col-10 mx-auto mb-5">
          <div class="row align-items-start beneficios-list">
            <div class="col-12 col-md-6 col-lg-4 d-flex justify-content-center beneficio-card my-3">
              <img src="@/assets/images/beneficio-alimentacao.svg" alt="Vale Alimentação, Restaurante, Vale Natal" class=""/>
            </div>

            <div class="col-12 col-md-6 col-lg-4 d-flex justify-content-center beneficio-card my-3">
              <img src="@/assets/images/beneficio-saude.svg" alt="Plano de Saúde, Plano odontológico, Programas e Linhas de Cuidado Saúde" class=""/>
            </div>
            
            <div class="col-12 col-md-6 col-lg-4 d-flex justify-content-center beneficio-card my-3">
              <img src="@/assets/images/beneficio-bem-estar.svg" alt="Gympass, Auxílio Home Office*, Day off no aniversário, Auxílio Pet, Auxílio à Nutrição Infantil e Material Escolar, 120 dias de Licença Parental (papais e mamães)" class=""/>
            </div>
            
            <div class="col-12 col-md-6 col-lg-4 d-flex justify-content-center beneficio-card my-3">
              <img src="@/assets/images/beneficio-mobilidade.svg" alt="Vale transporte (presencial/híbrido), Transporte fretado (presencial/híbrido)" class=""/>
            </div>
            
            <div class="col-12 col-md-6 col-lg-4 d-flex justify-content-center beneficio-card my-3">
              <img src="@/assets/images/beneficio-seguro.svg" alt="Seguro de Vida, Auxílio funeral" class=""/>
            </div>
            
            <div class="col-12 col-md-6 col-lg-4 d-flex justify-content-center beneficio-card my-3">
              <img src="@/assets/images/beneficio-produtos.svg" alt="Desconto exclusivo nos produtos GB." class=""/>
            </div>

            <!-- <div class="col-12 d-flex justify-content-end pt-5">
              <div class="detalhe"></div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="row" id="areas">
      <div class="col-12 col-md-10 mx-auto">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-center mb-4 mb-md-5 pb-md-5">
              <img src="@/assets/images/areas-title.svg" alt="Título aqui você poderá trilhar seu desenvolvimento nas áreas de:" />
            </div>
          </div>

          <div class="d-flex d-md-none areas-items">
            <div class="areas-items-item">
              <img src="@/assets/images/card-varejo-interna.svg" alt="" />
            </div>

            <div class="areas-items-item">
              <img src="@/assets/images/card-assuntos-corporativos.svg" alt="" />
            </div>

            <div class="areas-items-item">
              <img src="@/assets/images/card-b2b.svg" alt="" />
            </div>

            <div class="areas-items-item">
              <img src="@/assets/images/card-b2c.svg" alt="" />
            </div>

            <div class="areas-items-item">
              <img src="@/assets/images/card-consumer.svg" alt="" />
            </div>

            <div class="areas-items-item">
              <img src="@/assets/images/card-estrategia-financas.svg" alt="" />
            </div>

            <div class="areas-items-item">
              <img src="@/assets/images/card-gente.svg" alt="" />
            </div>

            <div class="areas-items-item">
              <img src="@/assets/images/card-operacoes.svg" alt="" />
            </div>

            <div class="areas-items-item">
              <img src="@/assets/images/card-tecnologia.svg" alt="" />
            </div>
          </div>

          <div class="col-12 d-none d-md-flex flex-wrap">

            <div class="col-12 col-md-4 mb-5">
              <b-btn block v-b-toggle="'collapse-areas-9'" variant="transparent">
                Varejo e Internacional
              </b-btn>
  
              <b-collapse id="collapse-areas-9" role="tabpanel" accordion="areas-accordion">
                <div class="collapse-content">
                  <p>Essa área é responsável pelo Varejo proprietário no país (Planejamento & Go to Market dos Canais - Lojas, Venda Direta e Omnicanalidade) e pelo desenvolvimento Internacional das marcas e modelos de negócio do GB em aproximadamente 40 países.</p>
                </div>
              </b-collapse>
            </div>

            <div class="col-12 col-md-4 mb-5">
              <b-btn block v-b-toggle="'collapse-areas-1'" variant="transparent">
                Assuntos corporativos
              </b-btn>
  
              <b-collapse id="collapse-areas-1" role="tabpanel" accordion="areas-accordion">
                <div class="collapse-content">
                  <p>Foca em iniciativas que reforçam a responsabilidade ESG do Grupo Boticário, incluindo conservação da natureza, diversidade, inclusão, governança, gestão jurídica, compliance e comunicação institucional, assegurando compromisso com sustentabilidade e práticas empresariais éticas.</p>
                </div>
              </b-collapse>
            </div>
  
            <div class="col-12 col-md-4 mb-5">
              <b-btn block v-b-toggle="'collapse-areas-2'" variant="transparent">
                B2B
              </b-btn>
  
              <b-collapse id="collapse-areas-2" role="tabpanel" accordion="areas-accordion">
                <div class="collapse-content">
                  <p>É dedicada a criar e fortalecer as relações comerciais entre pessoas jurídicas. Responsável pelo planejamento e Go-To-Market, Comercial Indireto, Comercial Direto e Trade Canal, o foco é ampliar o alcance e, consequentemente, aumentar as vendas e a representatividade das marcas no ponto de venda em canais como Farma e Alimentar. </p>
                </div>
              </b-collapse>
            </div>
  
            <div class="col-12 col-md-4 mb-5">
              <b-btn block v-b-toggle="'collapse-areas-3'" variant="transparent">
                B2C
              </b-btn>
  
              <b-collapse id="collapse-areas-3" role="tabpanel" accordion="areas-accordion">
                <div class="collapse-content">
                  <p>Foca na interação direta com o consumidor final, desenvolvendo e executando estratégias para a rede de franquias, digitalizando o canal de venda direta, alavancando o omnichannel, e-commerce e a experiência do cliente, com o objetivo de aprimorar a jornada do consumidor e criar oportunidades para a beleza transformar vidas.</p>
                </div>
              </b-collapse>
            </div>
  
            <div class="col-12 col-md-4 mb-5">
              <b-btn block v-b-toggle="'collapse-areas-4'" variant="transparent">
                Consumer
              </b-btn>
  
              <b-collapse id="collapse-areas-4" role="tabpanel" accordion="areas-accordion">
                <div class="collapse-content">
                  <p>Responsável por entender as necessidades dos consumidores, gerir o portfólio de produtos, executar estratégias de marca e comunicação, com foco na inovação, planejamento de demanda e personalização de experiências para fidelizar clientes e aumentar a participação de mercado.</p>
                </div>
              </b-collapse>
            </div>

            <div class="col-12 col-md-4 mb-5">
              <b-btn block v-b-toggle="'collapse-areas-6'" variant="transparent">
                Estratégia e Finanças
              </b-btn>
  
              <b-collapse id="collapse-areas-6" role="tabpanel" accordion="areas-accordion">
                <div class="collapse-content">
                  <p>Responsável pela sustentabilidade financeira e estratégica do Grupo Boticário. Ela se concentra em desenhar o planejamento estratégico, realizar a gestão da governança, desenvolver políticas para mitigar riscos operacionais e desenvolver soluções financeiras robustas para apoiar o crescimento e a inovação da empresa.</p>
                </div>
              </b-collapse>
            </div>
  
            <div class="col-12 col-md-4 mb-5">
              <b-btn block v-b-toggle="'collapse-areas-5'" variant="transparent">
                Gente
              </b-btn>
  
              <b-collapse id="collapse-areas-5" role="tabpanel" accordion="areas-accordion">
                <div class="collapse-content">
                  <p>Responsável por conduzir iniciativas que assegurem nossos objetivos através da gestão de pessoas, gerando valor para o negócio por meio da estratégia de gente, incluindo cultura, talentos, desenvolvimento de competências e saúde corporativa.</p>
                </div>
              </b-collapse>
            </div>

  
            <div class="col-12 col-md-4 mb-5">
              <b-btn block v-b-toggle="'collapse-areas-7'" variant="transparent">
                Operações
              </b-btn>
  
              <b-collapse id="collapse-areas-7" role="tabpanel" accordion="areas-accordion">
                <div class="collapse-content">
                  <p>Responsável por toda a cadeia produtiva do Grupo Boticário, desde o desenvolvimento e produção até o controle de qualidade e segurança industrial, utilizando tecnologias inovadoras para otimizar processos, melhorar performance, garantir qualidade e impulsionar a sustentabilidade.</p>
                </div>
              </b-collapse>
            </div>
  
            <div class="col-12 col-md-4 mb-5">
              <b-btn block v-b-toggle="'collapse-areas-8'" variant="transparent">
                Tecnologia
              </b-btn>
  
              <b-collapse id="collapse-areas-8" role="tabpanel" accordion="areas-accordion">
                <div class="collapse-content">
                  <p>Voltada para a inovação digital e eficiência tecnológica, isso inclui o desenvolvimento de produtos digitais e produtos estruturantes, gestão da segurança da informação e impulsionamento da cultura de dados. O objetivo é proporcionar soluções tecnológicas e uso de dados para impulsionar o negócio.</p>
                </div>
              </b-collapse>
            </div>

            
          </div>

          <!-- <div class="col-12 mb-5">
            <div class="d-none d-md-flex justify-content-center">
              <a 
                href="https://docs.google.com/document/d/19NuBICj3a2ZxAMv0M0qtlViw8u7pZUQgttB4xyN6PrY/edit?usp=sharing"
                target="_blank"
                class="btn btn-color-1 quero-saber-mais"
              >
                Quero saber mais sobre as áreas de atuação
              </a>
            </div>

            <div class="d-flex d-md-none saiba-mais-mobile">
              <p>
                Saiba mais sobre as áreas de atuação <a href="https://docs.google.com/document/d/19NuBICj3a2ZxAMv0M0qtlViw8u7pZUQgttB4xyN6PrY/edit?usp=sharing" target="_blank">aqui</a>.
              </p>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="row" id="etapas">
      <div class="col-12 col-md-8">
        <div class="d-none d-md-flex justify-content-center mb-5 pb-5">
          <img src="@/assets/images/etapas-title.svg" alt="Título Etapas do Processo" />
        </div>

        <div class="d-flex d-md-none justify-content-center mb-5">
          <img src="@/assets/images/etapas-title-mobile.svg" alt="Título Etapas do Processo" />
        </div>
      </div>
      
      <div class="col-10 col-md-10 mx-auto etapas-list">
        <div class="row etapas-line">
          <div class="col-3 etapa"></div>
          <div class="col-2 etapa"></div>
          <div class="col-3 etapa"></div>
          <div class="col-2 etapa"></div>
          <div class="col-2 etapa"></div>
        </div>

        <div class="row etapas-labels">
          <div class="col-12 col-md-3 etapa">
            <h1>Inscrições <span>+ testes On-line</span></h1>
            
            <p>Outubro</p>
          </div>
          
          <div class="col-12 col-md-2 etapa">
            <h1>Dinâmica <span>On-line</span></h1>
            
            <p>Novembro</p>
          </div>
          
          <div class="col-12 col-md-3 etapa">
            <h1>Entrevistas com Lideranças do GB<span>On-line</span></h1>
            
            <p>Novembro</p>
          </div>

          <div class="col-12 col-md-2 etapa">
            <h1>Painel <span>final on-line</span></h1>
            
            <p>Dezembro</p>
          </div>
          
          <div class="col-12 col-md-2 etapa">
            <h1>Aprovação <span>e Contratação</span></h1>
            
            <p>
              <span>Aprovação:</span> Dezembro<br/>
              <span>Início: </span>Janeiro
            </p>
          </div>
        </div>
      </div>

      <div class="d-none d-md-block col-12 mb-5">
        <div class="d-flex justify-content-center">
          <router-link :to="'/vagas/' + $store.state.bancoDeTalentos + '/inscricao'" class="btn btn-color-3 quero-estagiar">Quero ser Trainee no Grupo Boticário</router-link>
        </div>
      </div>
    </div>

    <div class="row mt-5 py-md-5 my-mb-5" id="depoimentos">
      <div class="col-7 col-md-9 mx-auto">
        <img src="@/assets/images/titulo-depoimentos.svg" alt="Título Quem faz por Aqui" />
      </div>

      <div class="col-12 col-md-9 mx-auto mt-4 d-flex justify-content-end">
        <div class="detalhe"></div>
      </div>

      <div class="d-none d-md-block col-md-8 mx-auto">
        <Slider items="3" slideBy="2" controls="true">
          <div>
            <div class="item">
              <div class="depoimento-card">
                <img src="@/assets/images/depoimentos-2025/viviane.png" alt="" />

                <p>Participar do programa trainee do GB impulsionou minha carreira, proporcionando não apenas oportunidades de crescimento profissional, mas também um desenvolvimento pessoal transformador. Liderar um projeto estratégico do Grupo me permitiu explorar novas áreas de interesse e entender melhor meus objetivos profissionais e oportunidades dentro do ecossistema do GB.
                </p>

                <p>Para além do profissional, a jornada foi ainda mais poderosa pelos contatos com lideranças seniores,  o apoio de mentores e colegas comprometidos com meu desenvolvimento. No fim, ser trainee em uma empresa com a cultura do GB é sobre isso: crescer como um profissional capaz de lidar com as complexidades do negócio, valorizando a importância de ter pessoas incríveis ao seu lado.
                </p>

                <div class="depoimento-card-footer">
                  <h6>Viviane <strong>Cavalcante</strong></h6>
                  <p><span>/ / </span>Especialista de Venda Direta</p>
                  <p>Ex trainee 2023</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="item">
              <div class="depoimento-card">
                <img src="@/assets/images/depoimentos-2025/mariana.jpg" alt="" />

                <p>O programa trainee foi um acelerador de carreira que me permitiu desenvolver habilidades e ampliar minha visão sobre negócio através das oportunidades do programa, com a trilha de aprendizados e com a oportunidade de tocar projetos com autonomia e interagir com diferentes áreas, o que foi muito importante para meu crescimento profissional. Em especial, como trainee no Grupo Boticário pude vivenciar de perto a cultura de uma empresa que vive para levar beleza para as pessoas, com valores e propósito que se materializam em todos os lugares, da fábrica aos revendedores, o que me fez ficar ainda mais encantada e orgulhosa de ser parte do GB.
                </p>

                <div class="depoimento-card-footer">
                  <h6>Mariana <strong>Dafne</strong></h6>
                  <p><span>/ / </span>Especialista CVM</p>
                  <p>Ex trainee 2023</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="item">
              <div class="depoimento-card">
                <img src="@/assets/images/depoimentos-2025/yaman.png" alt="" />

                <p>O trainee pra mim foi um livro em branco onde eu tive a oportunidade de escrever a minha história por um novo ângulo, e com a certeza de que poderia transformar ainda mais pessoas através da beleza. Além de ter o privilégio de conhecer a cadeia gigantesca do GB, também coloquei a mão na massa em diferentes projetos ao lado de lideranças inspiradoras. Desde então, pude mudar o jogo na digitalização da VD, nos dados de CX e agora na liderança da comunicação em loja. Ser trainee é sobre isso: ter coragem e ser inconformado sem perder de vista o poder da nossa transformação.</p>

                <div class="depoimento-card-footer">
                  <h6>Yaman <strong>Moussa</strong></h6>
                  <p><span>/ / </span>Gerente de Visual Merchandising</p>
                  <p>Ex Trainee 2020</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="item">
              <div class="depoimento-card">
                <img src="@/assets/images/depoimentos-2025/leo.png" alt="" />

                <p>Comecei minha jornada no mercado de trabalho da melhor forma possível: como Trainee GB
                </p>

                <p>Participar desse programa foi uma experiência incrível! Tive a oportunidade de aprender na prática coisas que jamais veria em nenhum outro lugar. Desde os bastidores da operação, com direito a colocar a mão na massa no estoque de uma loja, até a apresentar o modelo de estratégia comercial para uma região inteira do Brasil, cada dia foi um aprendizado único.
                </p>

                <p>E o melhor de tudo? Contei com o apoio de pessoas incríveis durante toda a trajetória! O programa me conectou com mentes brilhantes que me incentivaram e me ajudaram a crescer profissionalmente.
                </p>

                <p>Olhando para trás, não consigo imaginar uma forma melhor de ter começado minha carreira. Agradeço ao GB por essa experiência transformadora!</p>

                <div class="depoimento-card-footer">
                  <h6>Leonardo <strong>Magalhaes</strong></h6>
                  <p><span>/ / </span>Gerente Atracao Talentos</p>
                  <p>Ex trainee 2019</p>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>

      <div class="d-block d-md-none col-md-8 mx-auto">
        <Slider items="1.2" slideBy="1.2">
          <div>
            <div class="item">
              <div class="depoimento-card">
                <img src="@/assets/images/depoimentos-2025/viviane.png" alt="" />

                <p>Participar do programa trainee do GB impulsionou minha carreira, proporcionando não apenas oportunidades de crescimento profissional, mas também um desenvolvimento pessoal transformador. Liderar um projeto estratégico do Grupo me permitiu explorar novas áreas de interesse e entender melhor meus objetivos profissionais e oportunidades dentro do ecossistema do GB.
                </p>

                <p>Para além do profissional, a jornada foi ainda mais poderosa pelos contatos com lideranças seniores,  o apoio de mentores e colegas comprometidos com meu desenvolvimento. No fim, ser trainee em uma empresa com a cultura do GB é sobre isso: crescer como um profissional capaz de lidar com as complexidades do negócio, valorizando a importância de ter pessoas incríveis ao seu lado.
                </p>

                <div class="depoimento-card-footer">
                  <h6>Viviane <strong>Cavalcante</strong></h6>
                  <p><span>/ / </span>Especialista de Venda Direta</p>
                  <p>Ex trainee 2023</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="item">
              <div class="depoimento-card">
                <img src="@/assets/images/depoimentos-2025/mariana.jpg" alt="" />

                <p>O programa trainee foi um acelerador de carreira que me permitiu desenvolver habilidades e ampliar minha visão sobre negócio através das oportunidades do programa, com a trilha de aprendizados e com a oportunidade de tocar projetos com autonomia e interagir com diferentes áreas, o que foi muito importante para meu crescimento profissional. Em especial, como trainee no Grupo Boticário pude vivenciar de perto a cultura de uma empresa que vive para levar beleza para as pessoas, com valores e propósito que se materializam em todos os lugares, da fábrica aos revendedores, o que me fez ficar ainda mais encantada e orgulhosa de ser parte do GB.
                </p>

                <div class="depoimento-card-footer">
                  <h6>Mariana <strong>Dafne</strong></h6>
                  <p><span>/ / </span>Especialista CVM</p>
                  <p>Ex trainee 2023</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="item">
              <div class="depoimento-card">
                <img src="@/assets/images/depoimentos-2025/yaman.png" alt="" />

                <p>O trainee pra mim foi um livro em branco onde eu tive a oportunidade de escrever a minha história por um novo ângulo, e com a certeza de que poderia transformar ainda mais pessoas através da beleza. Além de ter o privilégio de conhecer a cadeia gigantesca do GB, também coloquei a mão na massa em diferentes projetos ao lado de lideranças inspiradoras. Desde então, pude mudar o jogo na digitalização da VD, nos dados de CX e agora na liderança da comunicação em loja. Ser trainee é sobre isso: ter coragem e ser inconformado sem perder de vista o poder da nossa transformação.</p>

                <div class="depoimento-card-footer">
                  <h6>Yaman <strong>Moussa</strong></h6>
                  <p><span>/ / </span>Gerente de Visual Merchandising</p>
                  <p>Ex Trainee 2020</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="item">
              <div class="depoimento-card">
                <img src="@/assets/images/depoimentos-2025/leo.png" alt="" />

                <p>Comecei minha jornada no mercado de trabalho da melhor forma possível: como Trainee GB
                </p>

                <p>Participar desse programa foi uma experiência incrível! Tive a oportunidade de aprender na prática coisas que jamais veria em nenhum outro lugar. Desde os bastidores da operação, com direito a colocar a mão na massa no estoque de uma loja, até a apresentar o modelo de estratégia comercial para uma região inteira do Brasil, cada dia foi um aprendizado único.
                </p>

                <p>E o melhor de tudo? Contei com o apoio de pessoas incríveis durante toda a trajetória! O programa me conectou com mentes brilhantes que me incentivaram e me ajudaram a crescer profissionalmente.
                </p>

                <p>Olhando para trás, não consigo imaginar uma forma melhor de ter começado minha carreira. Agradeço ao GB por essa experiência transformadora!</p>

                <div class="depoimento-card-footer">
                  <h6>Leonardo <strong>Magalhaes</strong></h6>
                  <p><span>/ / </span>Gerente Atracao Talentos</p>
                  <p>Ex trainee 2019</p>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </div>

    <div class="row" id="faq">
      <div class="col-10 mx-auto">
        <!-- <div class="detalhe mb-4"></div> -->
        <h1>FAQ <span>Programa de Trainee Grupo Boticário 2025</span></h1>
        
        <Faq />
      </div>

      <div class="d-none d-md-block col-12 mt-4">
        <div class="d-flex justify-content-center">
          <router-link :to="'/vagas/' + $store.state.bancoDeTalentos + '/inscricao'" class="btn btn-color-1 border-0 quero-estagiar">Quero ser trainee do Grupo Boticário</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Slider from "@/components/Slider.vue";
  import Faq from "@/components/Faq.vue";
  import Share from "@/components/jobs/Share.vue";

  import MagnifyIcon from "vue-material-design-icons/Magnify.vue";
  import scriptMixin from '@/scriptMixin.js';

  export default {
    name: "home",

    data() {
      return {
        galleryItem: 1,
        requisitosVisible: false,
      };
    },

    components: {
      Slider,
      Faq,
      Share,
      MagnifyIcon,
    },

    mixins: [scriptMixin],

    mounted() {
      this.loadTrackingScripts();

      // Cria um observer de interseção
      const observer = new IntersectionObserver((entries) => {
        // Atualiza a visibilidade com base na interseção
        entries.forEach((entry) => {
          this.requisitosVisible = entry.isIntersecting;
        });
      });

      // Observa o elemento referenciado
      observer.observe(this.$refs.requisitosElement);
    },

    methods: {
      scrollTop() {
        window.scrollTo(0, 0)
      },
    },
  };
</script>

<style lang="scss" scoped>
  .detalhe {
    width: 25px;
    height: 9px;
    background-image: url("../assets/images/detalhe-rosa.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn-subscribe-container {
    width: auto;
    @media (max-width: 768px) {
      width: 100%;
    }
  }

  #section-beneficios{
    background-image: url("../assets/images/bg-beneficios.png");
    background-repeat: no-repeat;
    background-position: left -100px;

    @media (max-width: 768px) {
      background-image: none;
    }
  }

  .sobre-video-content {
    // margin-top: -145px;
    // @media (max-width: 992px) {
    //   margin-top: initial;
    // }
  }

  .iframe-border {
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%;
    iframe {
      position: absolute;
      top: 10px;
      left: 10px;
      bottom: 10px;
      right: 10px;
      width: calc(100% - 20px);
      height: calc(100% - 20px);
    }

    &::before, &::after {
      content: "";
      width: 15px;
      height: 15px;
      position: absolute;
      border-radius: 2px;
    }

    &::before {
      top: 0;
      left: 0;
      border-top: 3px solid theme-color('color-1');
      border-left: 3px solid theme-color('color-1');
    }

    &::after {
      bottom: 0;
      right: 0;
      border-bottom: 3px solid theme-color('color-1');
      border-right: 3px solid theme-color('color-1');
    }
  }

  #pq-grupo-boticario{
    background-color: #001D37;
    background-image: url("../assets/images/pq-grupo-texts-bg.png");
    background-position: bottom right;
    background-repeat: no-repeat;
    background-size: 45%;
    padding: 50px 0;

    @media (max-width: 768px) {
      background-image: none;
    }
  }

  .numbers {
    padding: 200px 0 100px 0;
    background-image: url("../assets/images/vector-3.svg");
    background-size: 90%;
    background-position: top center;
    background-repeat: no-repeat;


    @media (max-width: 768px) {
      padding: 90px 0 0px 0;
      & > .row{
        overflow: auto;
        flex-wrap: nowrap;
        width: 100%;

        .col-3{
          min-width: 100%;
          flex-shrink: 0;
          max-width: none;
          flex: 1;

          .number-item{
            flex-direction: row;
            padding: 40px;
            width: auto;
            height: 100%;
            gap: 30px;
          }
        }
      }
    }
  }

  .number-item {
    width: 235px;
    height: 225px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 15px;
    border-radius: 20px;
    background-color: #F6F1EB;

    &-head {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
      p {
        font-size: 20px;
        line-height: 23px;
        font-weight: 700;
        color: #001D37;
        margin: 0;
        font-style: italic;

        span {
          font-weight: 100;
        }
      }
    }

    &-body {
      margin-top: 10px;
      p {
        font-size: 60px;
        line-height: 25px;
        font-weight: 700;
        color: #001D37;
        text-align: center;
        span {
          font-size: 20px;
          font-weight: 400;
          line-height: 0;
        }  
      }
    }
  }

  .container-numbers {
    height: 150px;
    align-items: flex-end;
    overflow-x: auto;
    white-space: nowrap;
    background-image: url("../assets/images/vector-3.svg");
    background-size: 100%;
    background-position: top center;
    background-repeat: no-repeat;
    .number {
      flex: 0 0 auto;
      padding: 0 10px;
    }

    img {
      display: block;
      max-width: 100%;
      height: auto;
    }
  }

  #programa {
    position: relative;
    height: 380px;
    @media (max-width: 768px) {
      margin-bottom: 180px;
    }
    
    @media (max-width: 650px) {
      margin-bottom: 100px;
    }

    @media (max-width: 530px) {
      margin-bottom: 50px;
    }

    @media (max-width: 500px) {
      margin-bottom: 0;
    }

    &::before {
      content: "";
      height: 100%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      background-color: theme-color('color-1');
      @media (max-width: 768px) {
        height: 90%;
      }

      @media (max-width: 650px) {
        height: 80%;
      }

      @media (max-width: 530px) {
        height: 70%;
      }

      @media (max-width: 500px) {
        height: 65%;
      }
    }
  }

  .image-between {
    position: absolute;
    width: 100%;
    height: 180px;
    background-size: contain;
    background-image: url("../assets/images/bg-abeleza.png");
    background-position: top right;
    background-repeat: no-repeat;
  }

  #beleza {
    margin-top: 70px;
    @media (min-width: 768px) {
      margin-top: 200px;
      background-image: url("../assets/images/bg-abeleza.png");
      background-position: top right;
      background-repeat: no-repeat;
    }

    /deep/ .item {
      position: relative;
      padding-left: 15px;
      padding-bottom: 15px;
      &::before {
        content: "";
        position: absolute;
        top: 15px;
        left: -15px;
        width: 400px;
        height: 100%;
        background: #011E38;
        z-index: -1;
      }
    }
  }

  #collapses-beleza {
    justify-content: center;
    gap: 45px;
    .btn {
      font-weight: 500;
      color: #001D37;
      font-size: 18px;
      padding: 0;
      text-align: left;
      background-image: url("../assets/images/collapse-down.svg");
      background-position: center right;
      background-repeat: no-repeat;
      &[aria-expanded="true"] {
        background-image: url("../assets/images/collapse-up.svg");
      }
    }

    p {
      margin-top: 20px;
      font-size: 16px;
      font-weight: normal;
      line-height: 1.6;
      color: #464646;
    }

    .collapses-beleza-item {
      max-width: 240px;
      @media (max-width: 768px) {
        max-width: initial;
        &:not(:last-child) {
          margin-bottom: 40px;
          height: auto;
          border-bottom: 1.7px solid #DCDCDC;
          padding-bottom: 15px;
        }
      }
    }
  }

  .requisitos-title-mobile {
    position: relative;
    align-items: center;
    margin-top: 100px;
    margin-left: 20px;
    margin-bottom: -290px;
    .img-avatar {
      max-width: 170px;
    }

    .img-title {
      position: absolute;
      width: 190px;
      left: 160px;
    }
  }

  #requisitos {
    background-color: #001D37;
    overflow: hidden;
    // padding-bottom: 100px;
    &.visible {
      .requisitos-bg {
        .requisitos-color {
          &::before {
            height: 800px;
          }
        }
      }
    }

    .content-text {
      padding-top: 50px;
      // max-width: 600px;
      // @media (max-width: 768px) {
      //   max-width: 350px;
      // }
    }

    .requisitos-bg {
      position: relative;
      .requisitos-color {
        &::before {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: -220px;
          height: 50px;
          background-color: theme-color('color-1');
          transition: height 1s cubic-bezier(0.175, 0.885, 0.32, 1.1);
          @media (max-width: 768px) {
            left: -70px;
            border-bottom-left-radius: 30px;
          }
        }
      }
    }

    .requisitos-content {
      padding: 0 40px;
      @media (max-width: 768px) {
        margin-top: 200px;
      }
    }
  }

  .areas-items {
    align-items: flex-end;
    overflow-x: auto;
    white-space: nowrap;
    &-item {
      flex: 0 0 auto;
      &:first-child {
        margin-left: 20px;
      }

      &:not(:first-child) {
        margin-left: -30px;
      }

      img {
        display: block;
        max-width: 100%;
        height: auto;
      }
    }
  }

  #sustentabilidade{
    margin-top: 50px;
    height: 800px;
    background-image: url("../assets/images/bg-sustentabilidade.png");
    background-position: bottom left;
    background-repeat: no-repeat;
    background-size: contain;

    @media (max-width: 768px) {
      background-image: none;
      height: auto;
      margin-top: 0;
    }

    p{
      margin: 0 35px 25px 35px;

      small{
        font-size: 12px;
        display: inline-block;
        line-height: 1.5;
      }
    }
  }

  #section-carreira-desenvolvimento{

    position: relative;
    &::after{
      content: "";
      display: block;
      width: 170px;
      height: 479px;
      background-image: url("../assets/images/bg-carreira-desenvolvimento.png");
      background-position: bottom right;
      background-repeat: no-repeat;
      background-clip: border-box;
      position: absolute;
      bottom: -200px;
      right: 0;

      @media (max-width: 768px) {
        bottom: 0;
      }
    }
  }

  #collapses-desenvolvimento{
    /deep/ .btn{
      font-size: 24px;
      line-height: 1.2;
      text-align: left;
      font-style: italic;
      padding: 0;
      display: flex;
      gap: 15px;
      margin-bottom: 10px;
      font-weight: 500;

      strong{
        font-weight: bold;
        font-style: normal;
      }
       
      span:first-of-type{
        font-weight: bold;
        font-size: 42px;
      }
    }
  }

  #areas {
    border-top-left-radius: 100px;
    padding-top: 50px;
    // margin-top: -100px;
    background-color: #001D37;
    color: #F6F1EB;
    .quero-saber-mais {
      text-transform: uppercase;
      font-size: 22px;
      font-weight: bold;
      padding: 10px 30px;
      cursor: pointer;
      &:hover {
        background-color: #FFBC82;
        color: #000;
      }
    }

    /deep/ .btn[aria-expanded] {
      color: #F6F1EB;
      font-weight: 600;
      font-size: 22px;
      text-align: left;
      padding: 0;
      margin-bottom: 20px;
      &::after {
        content: "";
        width: 40px;
        height: 3px;
        background-color: theme-color('color-1');
        will-change: width;
        display: block;
        transition: width 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      }
      
      &[aria-expanded="true"] {
        font-style: italic;
        &::after {
          width: 100px;
          background-color: #FFBC82;
        }
      }
    }

    .saiba-mais-mobile {
      max-width: 200px;
      margin: 50px auto 0;
      p {
        font-size: 18px;
        line-height: 25px;
        font-weight: 500;
        color: #464646;
        text-align: center;
        a {
          font-weight: 700;
          color: #004DF1;
          text-decoration: underline;
        }
      }
    }
  }

  .btn.quero-estagiar {
    cursor: pointer;
    text-transform: uppercase;
    font-size: 22px;
    font-weight: bold;
    padding: 10px 30px;
    border: 2px solid #000;
    &:hover {
      background-color: theme-color('color-2');
      border-color: #000;
    }
  }

  #etapas {
    height: auto;
    padding: 80px 0 40px 0;
    background-color: theme-color('color-1');
    background-image: url('../assets/images/etapas-processo-background-topo.png');
    background-position: top right;
    background-repeat: no-repeat;
    @media (max-width: 768px) {
      background-size: 200px;
      background-position: -20px 0;
    }

    .etapas-list {
      margin-bottom: 80px;
      @media (max-width: 768px) {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        gap: 50px;
      }

      @media (max-width: 400px) {
        gap: 30px;
      }

      .etapas-line {
        height: 2px;
        margin-bottom: 30px;
        background-color: #fff;
        @media (max-width: 768px) {
          width: 2px;
          height: 100%;
          flex-direction: column;
        }

        @keyframes changeBgColor {
          0% {
            background-color: #FFBC82;
          }

          60%, 100% {
            background-color: black;
          }
        }

        .etapa {
          @media (max-width: 768px) {
            padding: 0;
          }

          &::before {
            content: "";
            display: block;
            width: 40px;
            height: 7px;
            margin-top: -3px;
            background-color: #000;
            animation: changeBgColor 6s infinite;
            @media (max-width: 768px) {
              width: 7px;
              height: 40px;
              margin: 0 0 0 -3px;
            }
          }

          &:nth-of-type(1)::before{ animation-delay: 0s; }
          &:nth-of-type(2)::before{ animation-delay: 1s; }
          &:nth-of-type(3)::before{ animation-delay: 2s; }
          &:nth-of-type(4)::before{ animation-delay: 3s; }
          &:nth-of-type(5)::before{ animation-delay: 4s; }
        }
      }

      .etapas-labels {
        @media (max-width: 768px) {
          max-width: 300px;
          flex-direction: column;
          flex-wrap: nowrap;
          gap: 50px;
          .etapa {
            width: max-content;
          }
        }

        h1 {
          font-size: 24px;
          line-height: 1;
          color: #fff;
          span {
            display: block;
            font-weight: 200;
            font-style: italic;
            @media (max-width: 768px) {
              display: initial;
            }

            @media (max-width: 600px) {
              display: block;
            }
          }
        }

        p {
          font-size: 16px;
          line-height: 25px;
          font-weight: 600;
          color: #fff;
          span {
            font-weight: 400;
            font-style: italic;
          }
        }
      }
    }
  }

  #depoimentos {
    /deep/ .carousel-container {
      position: relative;
      margin-top: 70px;
      @media (max-width: 768px) {
        margin-top: 30px;
        margin-left: 50px;
      }

      .item {
        padding: 40px 0 0 0;
      }

      .depoimento-card {
        position: relative;
        background-color: #004DF1;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        img {
          width: 80px;
          height: 80px;
          margin-top: -40px;
          border: 3px solid #fff;
          border-radius: 50%;
          object-fit: cover;
        }

        p {
          font-size: 16px;
          font-weight: 400;
          color: #FFFFFF;
          margin: 0;
          padding: 10px 25px;
          @media (max-width: 768px) {
            font-size: 11px;
            line-height: 20px;
            
          }
        }

        .depoimento-card-footer {
          background-color: #001D37;
          padding: 25px;
          align-self: stretch;
          border-radius: 0 0 20px 16px;
          h6 {
            color: #FFFFFF;
            font-size: 22px;
            font-weight: 400;
            font-style: italic;
            margin: 0;
            @media (max-width: 768px) {
              font-size: 18px;
              line-height: 21px;
            }

            strong {
              font-style: normal;
              font-weight: bold;
            }
          }

          p {
            color: #FFFFFF;
            font-size: 16px;
            margin: 0;
            padding: 0;
            font-style: italic;
            span {
              color: #FF5FCD;
              font-weight: bold;
              padding-right: 5px;
            }
          }
        }
      }
      
      .tns-controls {
        position: absolute;
        top: 50%;
        margin-top: -25px;
        left: -70px;
        right: -70px;
        display: flex;
        justify-content: space-between;
        button {
          width: 50px;
          height: 50px;
          border: none;
          background-color: transparent;
          background-size: cover;
          background-position: center;
          &[data-controls="prev"] {
            background-image: url("../assets/images/btn-prev.svg");
          }

          &[data-controls="next"] {
            background-image: url("../assets/images/btn-next.svg");
          }
        }
      }
    }
  }

  #faq {
    padding: 130px 0;
    @media (max-width: 768px) {
      padding: 120px 0;
    }

    h1 {
      font-size: 48px;
      font-weight: 700;
      line-height: 68px;
      letter-spacing: 0em;
      text-align: left;
      color: #000000;
      margin-bottom: 40px;
      @media (max-width: 600px) {
        font-size: 38px;
        line-height: 1.3;
      }

      span{
        font-size: 18px;
        font-weight: lighter;
        font-style: italic;
      }
    }

    /deep/li {
      list-style: disc;
      font-size: 20px;
      font-weight: 400;
      line-height: 36px;
      background-color: transparent;
      button {
        font-size: 18px;
        color: #011E38;
        // background-color: transparent;
        @media (max-width: 768px) {
          width: 100%;
          font-size: 18px;
          line-height: 22px;
          padding: 0;
          justify-content: space-between;
          gap: 10px;
        }

        .icon::before {
          font-size: 22px;
          font-weight: normal;
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        }
      }

      p {
        font-size: 16px;
        line-height: 1.5;
      }
      
      @media (max-width: 768px) {
        .icon {
          &::before {
            color: #004DF1;
          }
        }
      }
    }
  }
</style>
